import { HStack } from '@chakra-ui/react';
import React from 'react';
import { SearchControlled } from '@app/components/Search';
import { DropdownMenu } from '@app/components/DropdownMenu';
import { usePositionsFiltersState } from '@app/state/positionsFiltersStore';

const vaultsOptions = [
  { title: 'All', value: '' },
  { title: 'Ichi', value: 'ichi' },
  { title: 'Steer', value: 'steer' },
  { title: 'Gamma', value: 'gamma' }
];

export const PositionsFilters = () => {
  const {
    searchTerm,
    provider,
    actions: { setSearchTerm, setProvider }
  } = usePositionsFiltersState();

  return (
    <HStack
      gap={[10, 4]}
      paddingTop="22px"
      flexDirection={['column', 'row']}
      mt={4}
    >
      <SearchControlled
        title="Search by tokens"
        onSearch={val => setSearchTerm(val)}
        value={searchTerm}
      />
      <DropdownMenu
        items={vaultsOptions}
        title="LP Provider"
        onSelect={val => setProvider(val)}
        selected={provider}
      />
    </HStack>
  );
};
